import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { setStatus } from '~/modules/_errorHandling';
import { setAuthHeaders, storeAuthHeaders } from '~/modules/auth';
import { handleError } from '~/modules/flashes';

import config from '~/config';

const axiosInstance = axios.create({
  baseURL: config.api,
  // @todo Eventually, we might want to actually use cookies for auth.
  // withCredentials: true,
});

export const setupAxiosInterceptors = (store) => {
  // Request interceptor to add auth headers
  axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const { getState } = store;
      const state = getState();
      const { isSignedIn } = state.currentUser;
      const currentAuthToken = state.auth;

      if (isSignedIn) {
        Object.assign(config.headers, currentAuthToken);
      }

      return config;
    }
  );

  // Response interceptor to handle auth token updates
  axiosInstance.interceptors.response.use((response: AxiosResponse) => {
    const { getState, dispatch } = store;
    const state = getState();
    const currentAuthToken = state.auth;
    const responseHeaders = response.headers;

    if (
      currentAuthToken['access-token'] &&
      responseHeaders['access-token'] &&
      responseHeaders['access-token'] !== currentAuthToken['access-token']
    ) {
      const newAuthHeaders = {
        'access-token': responseHeaders['access-token'],
        client: responseHeaders['client'],
        uid: responseHeaders['uid'],
      };

      dispatch(setAuthHeaders(newAuthHeaders));
      storeAuthHeaders(responseHeaders, {});
    }

    return response;
  });

  // Response interceptor to handle errors
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error) => {
      const { dispatch } = store;
      const response = error.response;

      if (response?.status) {
        dispatch(setStatus(response.status));
      }

      if (response?.data) {
        const json = response.data;

        if (json.status === 'error') {
          dispatch(
            handleError(
              `${json.message} (Code: ${json.code})`,
              `ErrorCode_${json.code}`
            )
          );
        }
      }

      return Promise.reject(error);
    }
  );
};

export { axiosInstance as axios };
